import React, { useState } from "react";
import "./form.scss";
import { Link } from 'react-router-dom';

const FeedbackForm = () => {
    const [formData, setFormData] = useState({
        program_name: '',
        trainer_name: '',
        college_name: '',
        content_delivery: '',
        learnings: '',
        training_rating: '',
        improvements: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Feedback submitted:", formData);
        // Add your form submission logic here
    };

    return (
            <div className="feedback-form-wrapper"> 
            <div className="cover">
                <h2 className="feedback-title">Your feedback today can make a difference tomorrow.</h2>
                <form onSubmit={handleSubmit} className="feedback-form">
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="program_name">Program Name:</label>
                            <input
                                type="text"
                                id="program_name"
                                name="program_name"
                                placeholder="Enter the program name"
                                onChange={handleChange}
                                value={formData.program_name}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="trainer_name">Trainer Name:</label>
                            <input
                                type="text"
                                id="trainer_name"
                                name="trainer_name"
                                placeholder="Enter the trainer's name"
                                onChange={handleChange}
                                value={formData.trainer_name}
                                required
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="college_name">College Name:</label>
                            <input
                                type="text"
                                id="college_name"
                                name="college_name"
                                placeholder="Enter your college name"
                                onChange={handleChange}
                                value={formData.college_name}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="training_rating">Training Rating:</label>
                            <select
                                id="training_rating"
                                name="training_rating"
                                onChange={handleChange}
                                value={formData.training_rating}
                                required
                            >
                                <option value="" className="options">Select Rating</option>
                                <option value="1" className="options">1 - Poor</option>
                                <option value="2" className="options">2 - Fair</option>
                                <option value="3" className="options">3 - Good</option>
                                <option value="4" className="options">4 - Very Good</option>
                                <option value="5" className="options">5 - Excellent</option>
                            </select>
                        </div>
                        
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="learnings">Learnings:</label>
                            <textarea
                                type="text"
                                id="learnings"
                                name="learnings"
                                placeholder="Share your new learnings"
                                onChange={handleChange}
                                value={formData.learnings}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="content_delivery">Content Delivery:</label>
                            <textarea
                                type="text"
                                id="content_delivery"
                                name="content_delivery"
                                placeholder="How was the content delivered"
                                onChange={handleChange}
                                value={formData.content_delivery}
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group full-width">
                        <label htmlFor="improvements">Improvements:</label>
                        <textarea
                            type="text"
                            id="improvements"
                            name="improvements"
                            placeholder="Suggest improvements"
                            onChange={handleChange}
                            value={formData.improvements}
                            required
                        />
                    </div>

                    <button type="submit" className="submit-button"><Link to="/" style={{ color: 'white' }}>Submit Feedback</Link></button>
                </form>
                </div>
            </div>

    );
};

export default FeedbackForm;
